import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Panel, Table, Empty, StatusBadge } from "@/components/terminal";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export default function Audit() {
  const [events, setEvents] = useState(null);
  const [verify, setVerify] = useState(null);
  const load = () => api.get("/audit").then((r) => setEvents(r.data)).catch(() => {});
  const runVerify = async () => {
    const r = await api.get("/audit/verify");
    setVerify(r.data);
  };
  useEffect(() => { load(); runVerify(); }, []);
  if (!events) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="audit-page">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-xl font-bold">Audit Ledger</h2>
        <div className="flex items-center gap-3">
          {verify && (
            <span className={`badge ${verify.valid ? "bg-emerald-500/10 text-emerald-400 border-emerald-800/60" : "bg-red-500/10 text-red-400 border-red-800/60"}`} data-testid="audit-verify-result">
              {verify.valid ? <ShieldCheck className="w-3 h-3" /> : <ShieldAlert className="w-3 h-3" />}
              {verify.valid ? `CHAIN VALID (${verify.events_checked} events)` : `CHAIN BROKEN AT #${verify.broken_at_seq}`}
            </span>
          )}
          <Button data-testid="audit-verify-button" onClick={runVerify} variant="outline" size="sm" className="border-[#D4AF37]/50 text-[#D4AF37]">VERIFY HASH CHAIN</Button>
        </div>
      </div>
      <Panel title="Hash-Linked Immutable Event Chain" testId="audit-ledger-table">
        {events.length === 0 ? <Empty>No audit events.</Empty> : (
          <Table testId="audit-table" head={[{ label: "#", num: true }, { label: "Timestamp" }, { label: "Event" }, { label: "Actor" }, { label: "Payload" }, { label: "Hash" }]}>
            {events.map((e) => (
              <tr key={e.id} className="hover:bg-[#222630]" data-testid={`audit-row-${e.seq}`}>
                <td className="td-num text-slate-500">{e.seq}</td>
                <td className="td-cell font-mono whitespace-nowrap">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="td-cell font-semibold text-slate-100">{e.event_type.replace(/_/g, " ")}</td>
                <td className="td-cell text-slate-500">{e.actor}</td>
                <td className="td-cell font-mono text-[10px] text-slate-500 max-w-[320px] truncate" title={JSON.stringify(e.payload)}>{JSON.stringify(e.payload)}</td>
                <td className="td-cell font-mono text-[10px] text-slate-600" title={`prev: ${e.prev_hash}`}>{e.hash.slice(0, 12)}…</td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
